import React from "react";
import "./Common_Product_Card.css";
import { useNavigate } from "react-router-dom";
import Alert_Modal from "../common_modal/alert_modal/Alert_Modal";

const Common_Product_Card = ({category,data, button_color, background_color, ...props }) => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = React.useState(false);
  const handleCategoryClick = () => {
    // if (category?.eight_plus_status) {
    //   // Show modal if eight_plus_status is true
    //   setModalShow(true);
    // } else {
      // Directly navigate if not
      navigate(
        `${props?.goto}?category_name=${encodeURIComponent(
          category?.name
        )}&category_image=${encodeURIComponent(category?.image)}`
      );
    // }
  };
  return (
    <section
      className="Common_Product_Card"
     
    //   onClick={() => {
    //     navigate(props?.goto);
    //   }}
       style={{
    background: `linear-gradient(to bottom, ${background_color} -20%, #ffffff 100%)`
  }}
    >
      <div className={`outer_colored_card ${props?.theme_colour}`} onClick={handleCategoryClick}>
        <div className="img_holder">
          <img
            src={process.env.REACT_APP_IMG_URL + props?.prodImg}
            className="prod_img"
          />
        </div>

        <div className="text_holder" style={{ background: button_color }} onClick={handleCategoryClick}>
          <p className="prod_name"  >{props?.prodName}</p>
        </div>
      </div>
      <Alert_Modal
        url={`${props?.goto}?category_name=${encodeURIComponent(
          category?.name
        )}&category_image=${encodeURIComponent(category?.image)}`}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default Common_Product_Card;
